export default "__VITE_ASSET__3ad4e372__"